// Generated from @cascade/api-contracts. Do not edit.
// Run: pnpm --filter @cascade/api-client build

import type {
  TApiRequestOptions,
  TApiTransport,
} from '#request/request.types.ts';
import type { TExampleRequest, TExampleResponse } from './scope1.types.ts';

export const createScope1Api = (transport: TApiTransport) => ({
  /** Example endpoint */
  example: (payload: TExampleRequest, options?: TApiRequestOptions) =>
    transport.post<TExampleRequest, TExampleResponse>(
      '/example',
      payload,
      options,
    ),
});
